import { render, staticRenderFns } from "./FirstSale.vue?vue&type=template&id=6136f242&scoped=true"
import script from "./FirstSale.vue?vue&type=script&lang=js"
export * from "./FirstSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6136f242",
  null
  
)

export default component.exports